import { Injectable } from '@angular/core';
import { NgbModal, NgbModalConfig, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ContractInformationModalComponent } from '../../../components/contract-information-modal/contract-information-modal.component';
import { ContractDetails } from '../../models/contracts';

@Injectable({
  providedIn: 'root'
})
export class ContractDeatilsModalService {

  private modalRef!: NgbModalRef;

  constructor(
    private modalService: NgbModal, private modalConfig: NgbModalConfig
  ) {
    this.modalConfig.backdrop = 'static';
    this.modalConfig.keyboard = false;
  }

  open(contractDetails: ContractDetails, contractId: any,idReferenceContract:any) {
    this.modalRef = this.modalService.open(ContractInformationModalComponent);
    this.modalRef.componentInstance.modalRef = this.modalRef;
    this.modalRef.componentInstance.contractDetails = contractDetails;
    this.modalRef.componentInstance.contractId = contractId;
    this.modalRef.componentInstance.idReferenceContract = idReferenceContract;
    return this.modalRef;
  }
}
